module.exports = __webpack_public_path__ + "media/images/general/profileAvatar-white-624f4e3ec74a05cf5dc1501ead400440.svg";